import {ReactNode} from 'react';
import classes from './LayoutRoot.module.scss'
import Header from "./Header/Header";
import FirstUseTour from './FirstUseTour';
import Footer from "./Footer/Footer";
import {matchPath, useLocation} from "react-router-dom";
import useAuth from "../../../hooks/auth/useAuth";

interface LayoutRootProps {
  children: ReactNode
}

const LayoutRoot = ({children}: LayoutRootProps) => {

  const location = useLocation();

  const {isAuthenticated} = useAuth();
  const pathname = location.pathname.replace(/\/+$/, '').toLowerCase() || '/';
  const isAuthPage = pathname === '/login' || pathname === '/register'
    || pathname.startsWith('/reset-password');
  const isPublicReceipt = matchPath('/shared/receipt/:token', location.pathname) !== null;
  const hasOwnHeader = pathname === '/home' || pathname === '/groups'
    || pathname === '/receipts' || pathname === '/profile'
    || matchPath('/groups/details/:groupId', location.pathname) !== null
    || matchPath('/receipt/:receiptId', location.pathname) !== null;
  const isCreationPage = ['/groups/create', '/create/manual', '/create/scanned', '/create/scaned']
    .some(path => matchPath(path, location.pathname) !== null)
    || matchPath('/receipt/:receiptId/edit', location.pathname) !== null;

  const isFooterAvailableToShow = isAuthenticated && !isCreationPage
    && location.pathname !== '/create/resume';

  if (isPublicReceipt) {
    return (
      <div className={classes["public-layout"]}>
        <a className={classes["skip-link"]} href="#main-content">Skip to content</a>
        <main id="main-content" className={classes["public-layout__content"]}>
          {children}
        </main>
      </div>
    );
  }

  if (!isAuthenticated || isAuthPage) {
    return (
      <div className={classes["auth-layout"]}>
        <a className={classes["skip-link"]} href="#main-content">Skip to content</a>
        <main id="main-content" className={classes["auth-layout__content"]}>
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className={classes["layout-root"]}>
      <a className={classes["skip-link"]} href="#main-content">Skip to content</a>
      {!hasOwnHeader && !isCreationPage && (
        <div className={classes["layout-root__header"]}>
          <Header/>
        </div>
      )}
      <main
        id="main-content"
        className={
          isCreationPage
            ? classes["layout-root__outlet-creation"]
            : hasOwnHeader
              ? classes["layout-root__outlet-home"]
              : isFooterAvailableToShow
                ? classes["layout-root__outlet"]
                : classes["layout-root__outlet-without-footer"]
        }>
        {children}
      </main>
      <FirstUseTour/>
      {!isCreationPage && (
        <div className={classes["layout-root__footer"]}>
          <Footer isVisible={isFooterAvailableToShow}/>
        </div>
      )}
    </div>
  );
};

export default LayoutRoot;
